var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { getSegments } from "../utils/ReducerUtils.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let GarxCardResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/xCardApi/workspaces/");
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      return response && response.ExceptionMessage;
    });
  }
  resolveQualityAlerts(alertEngageData, action, workspaceId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/alerts/${action}?api-version=2022-12-01-internal`;
      const result = yield this._patch(alertEngageData, address);
      return result;
    });
  }
  loadToCheckEmptySc(workspaceId, scorecardId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/scorecards/${scorecardId}/slices?api-version=2021-11-01-preview`;
      const result = yield this._get(address);
      return result;
    });
  }
  getScorecardData(scorecardId, metrics, startDate, endDate, control, treatment, workspaceid, segmentName, segmentValue, triggerFilterFlag, filterCondition) {
    return __async(this, null, function* () {
      let finalResult = [];
      let result = {};
      const segments = getSegments(segmentName, segmentValue, triggerFilterFlag, filterCondition);
      let address = `${workspaceid}/scorecards/${scorecardId}/metrics?controlvariant=${control}&treatmentvariant=${treatment}&api-version=2022-12-01-internal&segments=${encodeURIComponent(
        segments
      )}&analysisStartTime=${new Date(startDate).toISOString()}&analysisEndTime=${new Date(endDate).toISOString()}&skip=0&top=1000`;
      let nextLink = "";
      do {
        result = yield this._get(address);
        if (result.statusCode !== 200) {
          return result;
        }
        result = result.getSuccessData(this._errorMessage);
        nextLink = result.nextLink;
        if (!!nextLink) {
          address = `${address.substring(0, address.indexOf("&skip"))}${nextLink.substring(nextLink.indexOf("&skip"))}`;
        }
        finalResult = finalResult.concat(result.value);
      } while (!!nextLink);
      return { value: finalResult };
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred.` })
], GarxCardResource.prototype, "loadToCheckEmptySc", 1);
__decorateClass([
  onError({ message: `An error occurred.` })
], GarxCardResource.prototype, "getScorecardData", 1);
GarxCardResource = __decorateClass([
  WPSProxyConverter()
], GarxCardResource);
const GarXCardResource = new GarxCardResource();
export {
  GarXCardResource as default
};
//# sourceMappingURL=GarxCard.resource.js.map
